import { DEFAULT_CURRENCY } from "./fx/currencies.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class Transaction {

    /** @type {string} */
    #date;
    /** @type {string} */
    #description;
    /** @type {number} */
    #value;
    /** @type {string|null} */
    #dataset;
    /** @type {Transaction|null} */
    #origin;  // multi-transactions
    /** @type {string} */
    #currency;
    /** @type {number|null} */
    #nativeValue = null;
    /** @type {string|null} */
    #nativeCurrency = null;
    /** @type {FxQuote|null} */
    #fxQuote = null;

    /**
     *
     * @param date {string}
     * @param description {string}
     * @param value {number}
     * @param dataset {string|null}
     * @param origin {Transaction|null}
     * @param currency {string|null}
     */
    constructor(date, description, value, dataset = null, origin = null, currency = null) {
        this.#date = date;
        this.#description = description;
        this.#value = value;
        this.#dataset = dataset;
        this.#origin = origin;
        this.#currency = (currency !== null && currency !== undefined && currency !== '')
                ? currency
                : DEFAULT_CURRENCY;
    }

    getDate() {
        return this.#date;
    }

    getDescription() {
        return this.#description;
    }

    getValue() {
        return this.#value;
    }

    getDataset() {
        return this.#dataset;
    }

    getOrigin() {
        return this.#origin;
    }

    getCurrency() {
        return this.#currency;
    }

    getNativeValue() {
        return (this.#nativeValue !== null) ? this.#nativeValue : this.#value;
    }

    getNativeCurrency() {
        return (this.#nativeCurrency !== null) ? this.#nativeCurrency : this.#currency;
    }

    getFxQuote() {
        return this.#fxQuote;
    }

    isConverted() {
        return this.#fxQuote !== null && this.#fxQuote.source !== 'identity';
    }

    /**
     * @param convertedValue {number}
     * @param targetCurrency {string}
     * @param quote {FxQuote}
     * @return {Transaction}
     */
    asConverted(convertedValue, targetCurrency, quote) {
        let copy = new Transaction(
                this.#date, this.#description, convertedValue, this.#dataset, this.#origin, targetCurrency);
        copy.#nativeValue = this.getNativeValue();
        copy.#nativeCurrency = this.getNativeCurrency();
        copy.#fxQuote = quote;
        return copy;
    }

    static comparator(a, b) {
        if (a.getDate() === b.getDate()) {
            return a.getDescription() > b.getDescription() ? 1 : -1;
        }
        return a.getDate() > b.getDate() ? 1 : -1;
    }
}
